import { SignUpStep } from "../store/signUp/types";

export const signUpFlow: SignUpStep[] = [
    'registerEmail',
    'createPassword',
    'verifyEmail',
    'personalInfo',
    'verifyPhoneNumber',
    'uploadProfilePhoto',
    'uploadPersonalID',
    'KYC',
    'workExperience',
    'education',
    'expertise',
    'uploadFiles',
    'reviewInfo',
];

export const genderList = [
    {
        id: 1,
        title: 'Male',
    },
    {
        id: 2,
        title: 'Female',
    },
    {
        id: 3,
        title: 'I choose not to disclose',
    },
];

export const veteranList = [
    {
        id: 1,
        title: 'I am not a protected veteran',
    },
    {
        id: 2,
        title: 'I identify as one or more of the classifications of protected veterans',
    },
    {
        id: 3,
        title: 'I choose not to disclose',
    },
];

export const raceList = [
    {
        id: 1,
        title: 'Hispanic or Latino',
    },
    {
        id: 2,
        title: 'White or Caucasian',
    },
    {
        id: 3,
        title: 'Black or African American',
    },
    {
        id: 4,
        title: 'Asian',
    },
    {
        id: 5,
        title: 'Native American or Alaskan Native',
    },
    {
        id: 6,
        title: 'Native Hawaiian or other Pacific Islander',
    },
    {
        id: 7,
        title: 'Two or more race',
    },
    {
        id: 8,
        title: 'I choose not to disclose',
    },
];

export const disabilityList = [
    {
        id: 1,
        title: 'Yes, I have a disability (or previously had a disability)',
    },
    {
        id: 2,
        title: 'No, I don’t have a disability',
    },
    {
        id: 3,
        title: 'I choose not to disclose',
    },
];

export const degreeList = [
    {
        id: 1,
        title: "High School or Secondary School",
    },
    {
        id: 2,
        title: "Associate Degree",
    },
    {
        id: 3,
        title: "Undergraduate or Bachelor's Degree",
    },
    {
        id: 4,
        title: "Postgraduate or Master's Degree",
    },
    {
        id: 5,
        title: "Doctorate or Ph.D.",
    },
    {
        id: 6,
        title: "Professional Degrees",
    },
];

export const companySizeList = [
    {
        id: 1,
        title: "Company (1 to 5 Employees)",
    },
    {
        id: 2,
        title: "Company (6 to 10 Employees)",
    },
    {
        id: 3,
        title: "Company (11 to 20 Employees)",
    },
    {
        id: 4,
        title: "Company (21 to 50 Employees)",
    },
    {
        id: 5,
        title: "Company (51 to 100 Employees)",
    },
    {
        id: 6,
        title: "Company (101 to 500 Employees)",
    },
    {
        id: 7,
        title: "Company (501 to 3500 Employees)",
    },
    {
        id: 8,
        title: "Company (3501 +  Employees)",
    },
    {
        id: 9,
        title: "Recruiting Firm",
    },
    {
        id: 10,
        title: "Staffing Agency",
    },
];

export const employerRoleList = [
    {
        id: 1,
        title: " Business Owner/Leader",
    },
    {
        id: 2,
        title: "Head of Department - HR/Talent",
    },
    {
        id: 3,
        title: "Head of Department - Other",
    },
    {
        id: 4,
        title: "Director - HR/Talent",
    },
    {
        id: 5,
        title: "Director - Other",
    },
    {
        id: 6,
        title: "Manager - HR/Talent",
    },
    {
        id: 7,
        title: "Manager - Other",
    },
    {
        id: 8,
        title: "Social Media Manager",
    },
    {
        id: 9,
        title: "Recruiter/Sourcer",
    },
    {
        id: 10,
        title: "Student/Intern",
    },
    {
        id: 11,
        title: "Job Seeker",
    },
];
